module.exports = __webpack_public_path__ + "static/media/shaq.b295fabb.jpg";